export const getColumnValue = (item, column, language = "zh") => {
  if (!item[column] || item[column] === 'null')
    return (language === 'zh') ? '无' : '';
  else return item[column];
}
